export default [
  {
    name: "Sync data",
    path: "/sync",
    component: () => import("@/modules/sync/pages/Sync"),
    meta: {
      ability: [
        {
          resource: "sync-data",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "View",
    path: "/sync/view/:id",
    component: () => import("@/modules/sync/pages/SyncDetails"),
    meta: {
      ability: [
        {
          resource: "sync-data/:id",
          actions: ["read"],
        },
      ],
    },
  },
];
